import type { RoomView } from '@concept/protocol';
import { orderedConceptColors, orderedCubeMarkerIds } from './marker-inventory';

export const TV_PLACEMENT_SLIDE_MS = 8_000;

export function latestTvHistory(room: RoomView, limit = 12) {
  return room.boardActivity.slice(-Math.max(0, limit));
}

export function connectedPlayerSummary(room: RoomView) {
  const connected = room.players.filter((player) => player.isConnected);
  return {
    count: connected.length,
    names: connected.map((player) => player.nickname),
  };
}

export function orderedTvPlacementIds(
  room: Pick<RoomView, 'board' | 'conceptOrder' | 'cubeOrder'>,
): string[] {
  return orderedConceptColors(room).flatMap((color) => {
    const conceptMarker = room.board.find(
      (marker) => marker.color === color && marker.kind === 'pawn',
    );
    return [
      ...(conceptMarker ? [conceptMarker.id] : []),
      ...orderedCubeMarkerIds(room, color),
    ];
  });
}

export function reconcileTvPlacementQueue(
  orderedIds: readonly string[],
  currentQueue: readonly string[],
  promotedIds: readonly string[] = [],
): string[] {
  const activeIds = new Set(orderedIds);
  const promoted = promotedIds.filter(
    (id, index) => activeIds.has(id) && promotedIds.indexOf(id) === index,
  );
  if (promoted.length > 0) {
    const promotedSet = new Set(promoted);
    return [...promoted, ...orderedIds.filter((id) => !promotedSet.has(id))];
  }

  const currentId = currentQueue.find((id) => activeIds.has(id));
  if (!currentId) return [...orderedIds];
  const currentIndex = orderedIds.indexOf(currentId);
  return [
    ...orderedIds.slice(currentIndex),
    ...orderedIds.slice(0, currentIndex),
  ];
}
